const FinancialAutoProcessingRoute = {
  path: '/accounting/FinancialAutoProcessing',
  load: () => import('./FinancialAutoProcessing'),
  protected: true,
};

export { FinancialAutoProcessingRoute };
